// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .custom-dropdown-router-link.hyperlink button {\n  padding: 0;\n}\n.custom-dropdown-router-link button.dropdown-toggle {\n  white-space: normal;\n}\n.custom-dropdown-router-link button.dropdown-toggle::after {\n  display: inline;\n}", ""]);
// Exports
module.exports = exports;
